import { Reviewer } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';
import { anonymousUser } from '@/domains/productDiscovery/ArticleReviews/components/ReviewCard/translations';

export const beautifyNickname = (reviewer: Reviewer): string =>
  `${reviewer?.firstName || anonymousUser}${reviewer?.city && ` - ${reviewer.city}`}${reviewer?.country && ` (${reviewer.country})`}`;
